export default {
  data() {
    return {
      unit: 0,
      linage: 2
    };
  },
  methods: {
    getHeight() {
      return this.$el.clientHeight;
    },
    getUnit() {
      this.unit = Math.floor(this.getHeight() / this.linage);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getUnit();

      window.addEventListener('resize', this.getUnit);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getUnit);
  }
};
